import { render, staticRenderFns } from "./HorseEdit.vue?vue&type=template&id=1b698de7&"
import script from "./HorseEdit.vue?vue&type=script&lang=js&"
export * from "./HorseEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports